import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FileInput, RadioButtons, Checkboxes, TabPanel } from '../../../FlowConfigurationInputs';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @param       showAlert - show alert
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Read({ action, showAlert, setOpenVariable, variables }) {
    const { t } = useTranslation();
    const [value, setValue] = useState(action.fields?.fileType?.value === 'TEXT' ? 1 : 0);
    const label = 'CONTENT.CONFIGURATION-FORM.EXCEL.OPEN.';
    const options = {
        fileInput: {
            checkExtension: (ext) => {
                if (ext !== 'csv') {
                    showAlert(t('CONTENT.CONFIGURATION-FORM.CSV-TEXT.READ.UPLOAD-CSV-ONLY'));
                    return false;
                }
                return true;
            },
            fileType: '.csv'
        },
        radioButtons: {
            data: [{
                value: 'ro',
                label: label + 'READ-ONLY'
            }, {
                value: 'rw',
                label: label + 'READ-WRITE'
            }],
            defaultValue: 'ro'
        },
        checkboxes: { label: label + 'SHEET-CONTAINS-A-HEADER' }
    }


    useEffect(() => {
        if (!action.fields.fileType) {
            action.fields.fileType = { value: "FILE" };

        } else {
            if (action.fields.fileType.value === "FILE") {
                setValue(0);
            } else {
                setValue(1)
            }
        }

    }, [action, variables])
    function handleChangeTabs(newValue) {
        if (newValue === 1) {
            action.fields.filePath.type = 'TEXT';
            action.fields.fileType.value = 'TEXT';
            action.fields.filePath.backup = { value: action.fields.filePath.value };
            action.fields.filePath.value = "";
            if (action.fields.filePath.backupText?.value) {
                action.fields.filePath.value = action.fields.filePath.backupText.value;
            }
        } else {
            action.fields.filePath.type = 'FILE';
            action.fields.fileType.value = 'FILE';

            action.fields.filePath.backupText = { value: action.fields.filePath.value }
            delete action.fields.filePath.value
            if (action.fields.filePath.backup?.value) {
                action.fields.filePath.value = action.fields.filePath.backup.value;
            }
        }
        setValue(newValue);
    }
    return (
        <div>
            <div className="form-element">
                {t(label + 'FILE-PATH')}
                <div className="condition-tabs">
                    <button
                        className={value === 0 ? 'condition-active' : ''}
                        onClick={() => handleChangeTabs(0)}>
                        {t(label + 'SELECT')}
                    </button>
                    <button
                        className={value === 1 ? 'condition-active' : ''}
                        onClick={() => handleChangeTabs(1)}>
                        {t(label + 'CUSTOM')}
                    </button>
                </div>
                <TabPanel value={value} index={0}>
                <FileInput action={action} inputName="filePath" options={options.fileInput} isRequired
                        isSize={true} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <TextInput action={action} inputName="filePath" isRequired={false} setOpenVariable={setOpenVariable}
                        variables={variables} fieldType="string" displayName={t(label + 'FILE-PATH')}/>
                </TabPanel>
            </div>
            <div className="form-element">
                {t(label + 'OPEN-AS')}
                <RadioButtons action={action} inputName="openAs" options={options.radioButtons} isRequired />
            </div>
            <div className="form-element">
                <Checkboxes action={action} inputName="sheetContains" options={options.checkboxes} />
            </div>
            <div className="form-element">
                {t('CONTENT.CONFIGURATION-FORM.CSV-TEXT.READ.ASSIGN-DATA')}
                <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable} filter="data table" isRequired />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
            <div className="form-element">
                {t('CONTENT.CONFIGURATION-FORM.CSV-TEXT.READ.ASSIGN-PATH')}
                <VariablePicker action={action} inputName="assignToVariable" variables={variables} setOpenVariable={setOpenVariable} filter="string" isRequired />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div>
        </div>
    )
}
export default Read;